import { render, staticRenderFns } from "./cGaugeStyle.vue?vue&type=template&id=fce96028&scoped=true&"
import script from "./cGaugeStyle.vue?vue&type=script&lang=js&"
export * from "./cGaugeStyle.vue?vue&type=script&lang=js&"
import style0 from "./cGaugeStyle.vue?vue&type=style&index=0&id=fce96028&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce96028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fce96028')) {
      api.createRecord('fce96028', component.options)
    } else {
      api.reload('fce96028', component.options)
    }
    module.hot.accept("./cGaugeStyle.vue?vue&type=template&id=fce96028&scoped=true&", function () {
      api.rerender('fce96028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/styleComp/cGaugeStyle.vue"
export default component.exports